import PropTypes from "prop-types"
import chevronLeftBlack from "images/layout/chevron-left-black.svg"

import "./header.scss"

const Header = ({ onClickBack, title }) => (
  <header styleName="onboarding-header">
    <button
      type="submit"
      styleName="back"
      className="back-button-fixed button-tertiary button-outlined button-with-icon only-icon-on-mobile"
      aria-label="Back button"
      onClick={() => {
        onClickBack()
      }}
    >
      <span
        className="button-icon"
        dangerouslySetInnerHTML={{
          __html: chevronLeftBlack,
        }}
      />
      <span className="hide-on-xs">Back</span>
    </button>
    <div styleName="spacer" />
    <h1>{title}</h1>
    <div styleName="spacer" />
  </header>
)

Header.propTypes = {
  onClickBack: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default Header
